import { createFileRoute } from "@tanstack/react-router";
import { ProposalEditorPage } from "@/features/proposaleditor/ProposalEditorPage";

export const Route = createFileRoute("/_app/proposals/$proposal/edit")({ component: Page });

function Page() {
  const { proposal } = Route.useParams();
  return <ProposalEditorPage id={proposal} />;
}
